import { pipe, Array as A, Record as R } from 'effect';

import type { ExportFormats } from '@/domain/documents/schemas';

// The grid view exports through AG Grid, which writes only these.
const GRID_EXPORT_FORMATS = ['csv', 'xlsx'];

export type ExportFormatOption = { value: string; label: string };

export const exportFormatOptions = (formats: ExportFormats, isGridView: boolean): ExportFormatOption[] =>
  pipe(
    R.toEntries(formats),
    A.filter(([value]) => !isGridView || A.contains(GRID_EXPORT_FORMATS, value)),
    A.map(([value, label]) => ({ value, label })),
  );
